<template>
  <div class="ChatExpertList">
    <div class="expert-cards-container">
      <div
        v-for="expert in experts"
        :key="expert.id"
        class="expert-card"
        @click="goToChat(expert)"
      >
        <!-- Left Section: Photo and Experience -->
        <div class="expert-left">
          <img
            :src="serverHostName + '/' + expert.picture"
            class="expert-avatar"
            v-if="expert.picture"
          />
          <img src="../assets/images/avatar.png" class="expert-avatar" v-else />
          <p class="expert-experience" v-if="expert.ra_experience">
            Exp: <span class="experience">{{ expert.ra_experience }}</span>
          </p>
        </div>

        <!-- Right Section: Details and Actions -->
        <div class="expert-right">
          <div class="expert-header">
            <span class="expert-name">{{ expert.full_name }}</span>
            <span class="expert-status">
              <!-- :class="expert.isOnline ? 'Online' : 'Busy'" -->
              <!-- {{ expert.isOnline ? "Online" : "Busy" }} -->
              Online
            </span>
          </div>
          <p class="expert-sebi " v-if="expert.sebi_register_number">
            SEBI NO. {{ expert.sebi_register_number }}
          </p>
          <p class="expert-sebi " v-else>&nbsp;</p>
          <p class="expert-tag flex">
            <img src="../assets/images/ChatImages/Tags Icon (2).svg" alt="" />
            <!-- <span class="left-margin-5">{{ expert.tags }}</span> -->
            <span class="left-margin-5">Long Term & Short Term</span>
          </p>
          <div class="expert-languages">
            <div class="flex">
              <img src="../assets/images/ChatImages/Language Icon.svg" alt="" />
              <!-- <span class="left-margin-5">{{ expert.languages }}</span> -->
              <span class="left-margin-5">English, Hindi, Marathi</span>
            </div>
            <button class="chat-btn">
              <span class="chat-icon"></span>Chat
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-drawer banner-drawer">
      <el-drawer
        :visible.sync="isChatBannerVisible"
        direction="btt"
        custom-class="chat-drawer"
        :modal="false"
        :show-close="false"
        :with-header="false"
        class="custom-drawer"
      >
        <!-- Banner Section Positioned Above the Content -->
        <div class="background-container">
          <div class="banner">
            <img src="../assets/images/ChatImages/Group 5536.svg" alt="" />
          </div>
          <div class="text-left">
            <h2><span class="highlighted">Now</span> Interact Live</h2>
            <h2>
              <img
                src="../assets/images/Chat Icon (2).svg"
                alt=""
                style="width:30px; height:30px; margin-bottom:-10px; margin-right:10px"
              />
              <span class="highlighted">With</span> SEBI Experts
            </h2>
          </div>

          <div class="features-top">
            <ul class="features-list">
              <li><span>Live 15min Chat</span></li>
              <li><span>Connect Instantly With SEBI Experts</span></li>
              <li><span>Real-Time Guidance</span></li>
            </ul>
          </div>

          <div class="image-right">
            <img
              src="../assets/images/ChatImages/Chat Illustration.svg"
              class="corner-image"
            />
          </div>
          <!-- Bottom Text Section -->
          <div
          class="bottom-text"
          style="display: flex; align-items: center;"
        >
          <p style="margin: 0;">
           
            StockAnts is a tech platform that supports retail users with live,
            interactive sessions with SEBI experts for market overviews.
          </p>
        </div>
        </div>
      </el-drawer>
    </div>

    <div class="bottom-drawer">
      <el-drawer
        :visible.sync="chatPlanDetailsPopup"
        direction="btt"
        custom-class="chat-drawer"
        :modal="false"
        :show-close="false"
      >
        <!-- Image -->
        <div class="flex-center">
          <img
            src="../assets/images/ChatImages/Group 5515.svg"
            alt=""
            class="floating-image-wrapper"
          />
        </div>

        <!-- Left and Right Sections -->
        <div class="drawer-content">
          <!-- Left Section -->
          <div class="left-section">
            <div class="inner-content">
              <h2 class="drawer-heading">"Your Investment Queries Answered"</h2>
              <p class="drawer-subtext">
                Unlock SEBI Expert Advice Anytime, Anywhere with
              </p>

              <div class="details-list">
                <div class="points">
                  <i class="el-icon-success"></i> Exclusive 15 mins Session
                </div>
                <div class="points">
                  <i class="el-icon-success"></i> Real-Time personalize
                  Financial Guidance
                </div>
                <div class="points">
                  <i class="el-icon-success"></i> Instant Validation of
                  Investment Idea
                </div>
              </div>
            </div>
          </div>

          <!-- Right Section: Table and Subscribe -->
          <div class="right-section">
            <div class="inner-content">
              <!-- Pricing Table with Radio Buttons -->

              <div class="pricing-table">
                <div class="flex-space-between table-titles">
                  <div>Select Plan</div>
                  <div>Validity</div>
                </div>
                <div
                  class="pricing-row"
                  v-for="(option, index) in chatPackages"
                  :key="index"
                  :class="{ 'active-row': selectedPackage === option.label }"
                >
                  <div class="pricing-column">
                    <el-radio v-model="selectedPackage" :label="option.label">
                      {{ option.label }}
                    </el-radio>
                  </div>
                  <div class="pricing-column price">
                    ₹ {{ option.price
                    }}<span style="font-size: .6rem; font-weight: 500;"
                      >/Chat</span
                    >
                  </div>
                  <div class="pricing-column duration">
                    {{ option.duration }} Days
                  </div>
                </div>
              </div>

              <!-- Subscribe Button -->
              <div class="flex-center">
                <el-button
                  type="primary"
                  class="full-width-btn"
                  :disabled="!selectedPackage || !acceptTerms"
                  @click="getOrderId()"
                  :loading="is_purchase_plan_in_progress"
                >
                  Subscribe
                </el-button>
              </div>

              <!-- Terms and Conditions -->
              <div class="agreement-checkbox">
                <el-checkbox v-model="acceptTerms"> </el-checkbox>
                <p>
                  I Accept
                  <router-link
                    to="/retail-side/terms-condition"
                    style="color: #2488ff;"
                    >Terms and Conditions</router-link
                  >
                  and
                  <router-link
                    to="/retail-side/terms-condition"
                    style="color: #2488ff;"
                    >Chat Agreement</router-link
                  >.
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>

    <el-dialog
      :visible.sync="isStartChatPopupVisible"
      class="start-chat-popup"
      :show-close="false"
    >
      <i
        class="el-icon-error cursor-pointer"
        @click="isStartChatPopupVisible = false"
      ></i>
      <div class="popup-content">
        <!-- Title and Partition Line -->
        <h3 class="popup-title">What Best Describes You?</h3>
        <div class="partition-line"></div>

        <!-- Buttons (Beginner, Investor, Trader) -->
        <div class="button-group">
          <button
            class="category-btn"
            size="large"
            :class="{ active: selectedCategory === 'Beginner' }"
            @click="selectCategory('Beginner')"
          >
            Beginner
          </button>
          <button
            class="category-btn"
            size="large"
            :class="{ active: selectedCategory === 'Investor' }"
            @click="selectCategory('Investor')"
          >
            Investor
          </button>
          <button
            class="category-btn"
            size="large"
            :class="{ active: selectedCategory === 'Trader' }"
            @click="selectCategory('Trader')"
          >
            Trader
          </button>
        </div>

        <!-- Compulsory Checkbox -->
        <div class="agreement-text">
          <el-checkbox v-model="isAgreementAccepted" style="margin-right: 7px;">
          </el-checkbox>
          <p>
            I agree that the SEBI Expert can only guide me using the skills and
            expertise mentioned. I understand and accept the limitations of the
            SEBI Expert. I acknowledge that the expert is not responsible for
            any profits or losses, and I will take full responsibility for
            conducting my own research before making any investment or trading
            decisions.
          </p>
        </div>

        <!-- Chat Button -->
        <div class="chat-btn-container">
          <button
            class="chat-btn"
            :disabled="!isAgreementAccepted || !selectedCategory"
            @click="saveInvestorStageToProfileData()"
          >
            Start Chat
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="isChatInitiatedPopupVisible"
      class="start-chat-popup chat-initiated"
      :show-close="false"
    >
      <div class="popup-content">
        <div class="loading-div" v-loading="isChatInitiatedLoading"></div>
        <h4>Chat Initiated</h4>

        <p>
          Expert will take
          <span style="color: #2488ff;"> 1-2 mins to accept Chat Request</span>
        </p>
      </div>
    </el-dialog>

    <div class="top-drawer">
      <el-drawer
        :visible.sync="chatAcceptedDrawer"
        direction="ttb"
        custom-class="chat-accepted-drawer"
        :modal="false"
        :show-close="false"
      >
        <div class="main-div">
          <div class="check-outer flex">
            <i class="el-icon-check"></i>
            <div>
              <div class="name">
                {{
                  selectedExpertForChat.full_name
                    ? selectedExpertForChat.full_name
                    : "Expert"
                }}
              </div>
              <div class="duration">15 Min Duration</div>
            </div>
          </div>

          <div class="waiting-time-section">
            <i class="el-icon-time"></i>
            <div>
              <div class="head">Please wait</div>
              <div class="sub-text">Expert is connecting</div>
              <div class="sub-text">Don't close the app</div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import cashfreePromise from "../mixins/cashfreeInit.js";
import CripNotice from "crip-vue-notice";
import { credentials, cashfreeCredentials } from "../mixins/Credentials.js";
import { HelperNetworkCallBack } from "../mixins/Helper";

export default {
  mixins: [HelperNetworkCallBack],

  props: ["experts"],
  
  data() {
    return {
      serverHostName: serverHostName,
      // experts: [],
      chatPlanDetailsPopup: false,
      chatAcceptedDrawer: false,
      selectedPackage: "1 Chat", // Radio button model to store the selected package
      acceptTerms: false, // Checkbox model for terms and conditions
      chatPackages: [
        { label: "1 Chat", price: 320, duration: 15, chatCount: 1 },
        { label: "3 Chats", price: 335, duration: 30, chatCount: 3 },
        { label: "5 Chats", price: 350, duration: 45, chatCount: 5 },
      ],
      is_purchase_plan_in_progress: false,
      session_id: null,
      order_id: "",
      internalTeamMailList: [
        "krishaa0801@gmail.com",
        "joshiakshay719@gmail.com",
        "fegde.mayur@gmail.com",
        "snehalvpatil25@gmail.com",
        "sumittarkas0001@gmail.com",
        "bid.pallavi@gmail.com",
        "pallavi.bid@stockants.com",
        "bhushanm705811@gmail.com",
        "admin@stockants.com",
        "sumittarkas001@gmail.com",
        "satavchetan08@gmail.com",
        "amanm3047@gmail.com",
      ],
      userProfile: "",
      isStartChatPopupVisible: false,
      isAgreementAccepted: false,
      selectedCategory: null,
      isChatInitiatedPopupVisible: false,
      isChatInitiatedLoading: true,
      isChatBannerVisible: true,
      selectedExpertForChat: {},
      selectedCategory: null,
      selectedChatPlan: {},
    };
  },
  created() {
    this.userProfile = JSON.parse(localStorage.getItem("profile"));
    this.getPlanDetails();
  },

  methods: {
    saveInvestorStageToProfileData() {
      serverAddr
        .post("/auth/v1/partial_profile_update", {
          investment_profile: this.selectedCategory,
        })
        .then((response) => {
          if (response.data.status) {
            this.isStartChatPopupVisible = false;
            this.isChatInitiatedPopupVisible = true;

            setTimeout(() => {
              this.isChatInitiatedPopupVisible = false;
              this.chatAcceptedDrawer = true;
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectCategory(category) {
      this.selectedCategory = category;
    },
    // goToChat(expert) {
    //   this.selectedExpertForChat = expert;
    //   if (Object.keys(this.getChatPlanDetails).length) {
    //     this.isStartChatPopupVisible = true;
    //   } else {
    //     this.chatPlanDetailsPopup = true;
    //   }
    // },

    goToChat(expert) {
      this.isChatBannerVisible = !this.isChatBannerVisible;
    },
    getExpertList() {
      serverAddr
        // .get("/user/chat_expert_list")
        .get("/user/admin/chat_expert_list")
        .then((response) => {
          if (response.data.status) {
            var data = response.data.data;
            this.experts = data;
          }
        })
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },
    // getExpertList() {
    //   serverAddr
    //     .get("/user/chat_expert_list")
    //     .then((response) => {
    //       if (response.data.status) {
    //         var data = response.data.data;
    //         this.experts = data;
    //       }
    //     })
    //     .catch(
    //       function (error) {
    //         console.log(error);
    //       }.bind(this)
    //     );
    // },

    getOrderId() {
      this.chatPlanDetailsPopup = false;
      // filter selected chat plan
      this.selectedChatPlan = this.chatPackages.find(
        (plan) => plan.label === this.selectedPackage
      );

      serverAddr
        .post("/payment/v3/generate_order_id/", {
          plan_name: "StockAnts Chat",
          days: this.selectedChatPlan.duration,
          amount: this.selectedChatPlan.price * this.selectedChatPlan.chatCount,
          order_category_id: 4,
          description: "Plan Subscription",
          pg: "CASHFREE",
        })
        .then((response) => {
          if (response.data.status) {
            this.order_id = response.data.data.order_id; //getting order id
            this.session_id = response.data.data.session_id;
            // init  payment mode
            // this.handlePaymentSelection();
            this.initCashfree();
          } else {
            new CripNotice({
              title: "Oops! Something went wrong!",
              description: "Please try again",
              type: "error",
              duration: 3,
            });
          }

          this.is_purchase_plan_in_progress = false; //disabled loader
        })
        .catch(
          function(error) {
            console.log(error);
            this.order_id = "";
            this.is_purchase_plan_in_progress = false; //disabled loader

            new CripNotice({
              title: "Oops! Something went wrong!",
              description: "Please try again",
              type: "error",
              duration: 3,
            });
          }.bind(this)
        );
    },

    async initCashfree() {
      try {
        // Wait for the cashfreePromise to resolve, which contains the initialized Cashfree SDK
        const cashfree = await cashfreePromise;

        // Check if this.session_id is defined and not empty
        if (!this.session_id) {
          console.error("Error: paymentSessionId is missing or undefined");
          return; // Exit the function if session_id is missing or undefined
        }

        var currentPrice =
          this.selectedChatPlan.price * this.selectedChatPlan.chatCount;

        if (this.internalTeamMailList.includes(this.userProfile.email)) {
          currentPrice = 1;
        }

        // Construct options for checkout
        const checkoutOptions = {
          paymentSessionId: this.session_id,
          appId: cashfreeCredentials.appId,
          orderId: this.order_id,
          orderAmount: currentPrice,
          // orderAmount: this.validity
          //   ? credentials.PREMIUM_COST_THIRTY_DAYS
          //   : credentials.PREMIUM_COST_SEVEN_DAYS,

          orderCurrency: "INR",
          customerName: credentials.NAME,
          redirectTarget: "_modal",
          // Add other necessary options
        };

        // Initiate payment using checkout
        cashfree.checkout(checkoutOptions).then((result) => {
          if (result.error) {
            // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
            console.log("User has closed the popup, Check for Payment Status");
            console.log(result.error);
          }
          if (result.redirect) {
            // This will be true when the payment redirection page couldnt be opened in the same window
            // This is an exceptional case only when the page is opened inside an inAppBrowser
            // In this case the customer will be redirected to return url once payment is completed
            console.log("Payment will be redirected");
          }
          if (result.paymentDetails) {
            // This will be called whenever the payment is completed irrespective of transaction status
            console.log("Payment has been completed, Check for Payment Status");

            this.is_confirm_plan_purchase_dialog_visible = false;
            // this.getTransactionDetailsFromCashFree();
            console.log(result.paymentDetails.paymentMessage);
            this.getCashfreeTransactionDetails();
          }
        });
      } catch (error) {
        console.error("Error initializing Cashfree SDK:", error);
      }
    },
    getCashfreeTransactionDetails() {
      if (this.order_id) {
        setTimeout(() => {
          serverAddr
            .get(`payment/v3/plan_details_from_order_id/${this.order_id}`)
            .then((response) => {
              // this.is_confirm_plan_purchase_dialog_visible = false;
              var plan_data = response.data.response;

              if (
                plan_data.extra_info.module == "PLAN_PURCHASED" &&
                plan_data.data.plan == "StockAnts Chat"
              ) {
                this.$store.commit("storePlanStatus", plan_data);
                this.$store.commit("commitQRCodePopup", false);
                if (plan_data.data.plan.length) {
                  this.$store.commit("storePaymentStatus", true);
                }
              }

              if (
                plan_data &&
                plan_data.extra_info.transaction_status == "SUCCESS" &&
                plan_data.data.plan == "StockAnts Chat"
              ) {
                this.$store.commit("commitChatPlanDetails", plan_data.data);
                this.saveSubscribedChatPlanDetails(plan_data.data);

                this.$store.commit("commitKycDialog", true);
              }
            })
            .catch(
              function(error) {
                console.log(error);
              }.bind(this)
            );
        }, 2000);
      }
    },

    getPlanDetails() {
      serverAddr
        .post("/stockants_pro/get-user-subscription/", {})
        .then((response) => {
          if (response.data.status) {
            var stockAntsChatPlan = response.data.data.find(
              (plan) => plan.plan === "StockAnts Chat"
            );
            stockAntsChatPlan = stockAntsChatPlan ? stockAntsChatPlan : {};

            // Save Publisher plan details
            this.$store.commit("commitChatPlanDetails", stockAntsChatPlan);
            this.saveSubscribedChatPlanDetails(stockAntsChatPlan);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  computed: {
    getChatPlanDetails() {
      return this.$store.state.chat_plan_details;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ChatExpertList {
  .expert-cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .expert-card {
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    width: calc(50% - 10px);
    box-sizing: border-box;
    background: #ffff;
    box-shadow: 0px 0px 10px 0px #dfdddd;
    min-width: 430px;
    // margin: auto;

    &:hover {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
  }

  .expert-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    text-align: center;
    background-color: #d8eaff;
    padding: 10px;
    border-radius: 10px 0 0 10px;

    .expert-avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin-bottom: 10px;
    }

    .expert-experience {
      font-size: 12px;
      color: #666;
    }

    p {
      margin: 0;
    }

    .experience {
      background-color: transparent;
      border: none;
      color: #2488ff;
      cursor: pointer;
      font-weight: 600;
      font-size: 11px;
    }
  }

  .expert-right {
    flex-grow: 1;
    padding: 15px 20px;

    .expert-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
    }

    .expert-name {
      font-size: 13px;
    }

    .expert-status {
      font-size: 12px;
      color: $theme-green-color;
      font-weight: 500;

      &.online {
        color: $theme-green-color;
      }

      &.busy {
        color: $primary-theme-color;
      }
    }

    .expert-sebi {
      margin: 5px 0;
      font-size: 10px;
      color: #000;
      font-weight: 500;
    }

    .expert-tag {
      font-size: 12px;
      margin-bottom: 5px;
      color: $text-muted;
    }

    .expert-languages {
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      color: $text-muted;

      .chat-btn {
        color: white;
        border: none;
        padding: 5px 13px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        background: #ffff;
        color: $theme-green-color;
        border: 1px solid $theme-green-color;
        border-radius: 16px;
        font-weight: 600;
        margin-left: auto;

        &:hover {
          background-color: $theme-green-color;
          color: #ffff;
        }

        .chat-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          margin-bottom: 0px;
          background-image: url("../assets/images/ChatImages/chatIconGreen.svg");
          background-size: cover;
        }

        &:hover .chat-icon {
          background-image: url("../assets/images/ChatImages/chatIconWhite.svg");
          /* Change to your hover image */
        }
      }
    }
  }

  .bottom-popup {
    bottom: 0 !important;
  }

  .start-chat-popup {
    .el-dialog {
      width: 585px;
      border-radius: 10px;
    }

    .el-dialog__header {
      padding: 7px;
      background-color: #2488ff;
      border-radius: 10px 10px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-icon-error {
      font-size: 25px;
      position: absolute;
      right: 10px;
      top: 30px;
      color: #c4c4c4;
    }

    .popup-content {
      padding: 20px 25px;
      text-align: center;

      /* Title Styling */
      .popup-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 0;
        color: #000;
      }

      /* Partition Line */
      .partition-line {
        width: 50px; // or 150px if preferred
        height: 1px;
        background-color: #000;
        margin: 0 auto 20px; // Center the line with auto margin
      }

      /* Button Group for Category Selection */
      .button-group {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 20px;
        gap: 20px;
        justify-content: center;

        .category-btn {
          padding: 15px;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          color: $text-muted;
          font-weight: 600;
          font-size: 14px;
          border: 1px solid transparent;
          width: 160px;

          &.active {
            background-color: #d8eaff;
            color: #2488ff;
            border: 1px solid #2488ff;
          }
        }
      }

      .agreement-text {
        display: flex;
        text-align: left;
        word-break: normal;

        p {
          margin: 4px 0 0;
          font-size: 10px;
          color: #000;
        }
      }

      /* Chat Button Styling */
      .chat-btn-container {
        .chat-btn {
          width: 120px;
          padding: 10px;
          background-color: #2488ff;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          margin-top: 20px;
          font-weight: 600;
          font-size: 12px;

          &:disabled {
            cursor: not-allowed;
          }

          &:hover:not(:disabled) {
            background-color: #2488ff;
          }
        }
      }
    }
  }
}

.custom-drawer {
  width: calc(100% - 270px) !important;
  left: 270px !important;
  height: auto !important;
  bottom: 0 !important;
  padding: 0px;
  padding-top: 0;
  z-index: 1001;
  overflow: auto;
  border-radius: 10px 10px 0 0;
}

/* Background Container Style */
.background-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-image: url("../assets/images/ChatImages/BackgroundImg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
}

.banner {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  padding: 10px 20px;
  border-radius: 8px;
}

.text-left {
  flex: 1;
  padding-left: 20px;
}

.text-left h2 {
  margin: 0;
  font-size: 30px;
  color: white;
}

.chat-icon {
  width: 30px;
  height: 30px;
  margin-bottom: -10px;
  margin-right: 10px;
}

.features-top {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: -10px;
  padding-left: 20px;
}

.features-list-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.features-list {
  list-style-type: none;
  padding: 0;
}

.features-list li {
  font-size: 15px;
  color: #ffffff;
  margin: 5px 0;
  position: relative;
}

.features-list li::before {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 10px;
  background-image: url("../assets/images/GreenTick.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.highlighted {
  font-weight: 500;
  font-size: 25px;
  color: white;
}

.bottom-text {
  position: absolute;
  bottom: 10px;
  left: 20px;
  width: calc(100% - 40px);
  font-size: 11px;
  font-weight: 500;
  color: #ffffff;
  padding: 40px 10px -10px 10px;
}

.image-right {
  flex: 1;
  text-align: center;
}

.image-right .corner-image {
  max-width: 180px;
}

/* Responsive Styles */
@media screen and (max-width: 968px) {
  .background-container {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px;
    align-items: start;
    padding: 10px;
    // margin-bottom:55px
  }

  .text-left,
  .features-top {
    grid-column: 1;
  }

  .text-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
    padding-left: 30;
  }

  .text-left h2 {
  font-size: 25px;
}
.features-list {
  margin-top:0px
}
.features-list li {
  font-size: 12px;
  font-weight: 500;
  padding-left:20px
}

.features-list li::before {
  width: 10px;
  height: 10px;
}

.highlighted {
  font-weight: 500;
  font-size: 20px;
}
  .features-top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-left: 0;
  }

  .chat-icon {
    width: 15px; 
    height: 15px;
  }

  .image-right {
    grid-column: 2; 
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .image-right .corner-image {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    max-width: 125px;
  }

  .bottom-text {
    position: absolute;
    bottom: 0; 
    left: 0;
    width: 100%;
    padding: 10px;
    font-size: 8px; 
    text-align: center;
    margin-left: 5px;
  }
  .banner {
    top : 13px
  }
}

@media (max-width: 920px) {
  .ChatExpertList {
    .expert-cards-container {
      justify-content: center;
    }

    .expert-card {
      width: 100%;
    }
  }
}

@media (max-width: 450px) {
  .ChatExpertListPage .expert-list-section {
    padding: 10px;
  }

  .ChatExpertList .expert-left {
    width: 80px;
  }

  .ChatExpertList .expert-card {
    min-width: auto;
  }

  .ChatExpertList .expert-right {
    padding: 10px 12px;

    .expert-languages {
      flex-wrap: wrap;

      .chat-btn {
        margin-top: 5px;
        font-size: 12px;
        padding: 3px 7px;

        i {
          font-size: 15px !important;
        }
      }
    }

    .expert-tag,
    .expert-status,
    .expert-languages {
      font-size: 10px;

      img {
        width: 15px;
      }
    }
  }

  .ChatExpertList .start-chat-popup .popup-content {
    .button-group .category-btn {
      width: 250px;
    }

    .popup-title {
      font-size: 16px;
    }
  }

  .background-container {
  position: absolute; /* Positioning it absolutely */
  bottom: 0; /* Aligning it to the bottom */
  left: 0; /* Start from the left edge */
  width: 100%; /* Full-width container */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 10px; /* Adjust padding if needed */
  margin-top: 0;
  gap: 0px;
}

.features-top,
.image-right,
.bottom-text {
  flex: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}

.features-top {
  margin-bottom: 30px;
}

.features-list {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.features-list li {
  text-align: left;
  font-size: 8px;
  font-weight: 500;
  margin: 5px;
}

.features-list li::before {
  width: 8px;
  height: 8px;
}

.text-left h2 {
  font-size: 18px;
}

.text-left {
  margin-top: 20px;
  font-weight: 300;
}

.highlighted {
  font-size: 15px;
  font-weight: 600;
}

.bottom-text {
  text-align: center;
  font-size: 7px;
  font-weight: 400;
  padding: 15px 0px;
  // margin-left: 10px;
}

.image-right .corner-image {
  position: relative;
  top: 60%;
  max-width: 115px;
}

}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ChatExpertList {
  .start-chat-popup {
    .el-dialog {
      width: 585px;
      border-radius: 10px;
    }

    .el-dialog__header {
      padding: 7px;
      background-color: #2488ff;
      border-radius: 10px 10px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-icon-error {
      font-size: 25px;
      position: absolute;
      right: 10px;
      top: 30px;
      color: #c4c4c4;
    }

    .popup-content {
      .checkbox-group {
        margin-bottom: 20px;
        text-align: left;

        .el-checkbox {
          margin-left: 10px;
        }
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #2488ff;
        border-color: #2488ff;
      }
    }
  }

  .chat-initiated {
    .el-dialog {
      width: 250px;
    }

    .el-loading-spinner .path {
      stroke: #2488ff !important;
      stroke-width: 6px !important;
    }

    .popup-content {
      padding: 20px;

      .loading-div {
        height: 30px;
        margin-top: 10px;
      }

      h4 {
        color: #000;
        margin: 10px 0;
        font-size: 14px;
      }

      p {
        margin: 0;
        font-size: 12px;
      }
    }
  }

  .chat-accepted-drawer {
  }

  .el-drawer__header {
    margin: 0;
    padding: 0;
  }

  .chat-drawer {
    .drawer-content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-around;

      .left-section {
        flex: 1;
        width: 60%;
        padding-right: 20px;

        .inner-content {
          width: 350px;
          margin: 0 auto;
        }

        .drawer-heading {
          font-size: 1.1rem;
          font-weight: bold;
          color: #2488ff;
          margin: 0;
        }

        .drawer-subtext {
          font-size: 0.7rem;
          color: #666;
          margin: 0;
          font-style: italic;
        }

        .details-list {
          padding: 0;
          margin: 20px 0;

          .points {
            display: flex;
            font-size: 12px;
            margin: 15px 0;
            font-weight: 500;

            i {
              font-size: 20px;
              position: relative;
              bottom: 3px;
              color: #2488ff;
              margin-right: 4px;
            }
          }
        }
      }

      .right-section {
        flex: 1;
        width: 350px;
        padding-left: 20px;

        .inner-content {
          width: 300px;
          margin: 0 auto;
        }

        .pricing-table {
          margin: 0 auto;

          .table-titles {
            font-size: 0.7rem;
            font-weight: 500;
            margin: 10px 0;
          }

          .pricing-row {
            display: flex;
            justify-content: space-between;
            padding: 10px;
            margin-bottom: 15px;
            border: 1px solid #ddd;
            border-radius: 8px;
            transition: background-color 0.3s;
            background-color: #fafafa;

            &:last-child {
              margin-bottom: 0;
            }

            &.active-row {
              background-color: #f0f8ff;
              border: 1px solid #2488ff;
              box-shadow: 0px 0px 6px 1px #c1c1c1;
            }

            .price {
              font-size: 0.9rem;
              font-weight: 600;
            }

            .duration {
              font-size: 0.7rem;
              color: $text-muted;
            }
          }

          .pricing-column {
            display: flex;
            align-items: center;

            .el-radio__label {
              color: #2488ff;
            }
          }
        }

        .full-width-btn {
          width: 100%;
          margin: 15px auto 0;
          background-color: #2488ff;
          color: white;
          font-weight: bold;
        }

        .agreement-checkbox {
          display: flex;
          align-items: baseline;

          .el-checkbox {
            margin-top: 7px;
            font-weight: 500;

            .is-checked .el-checkbox__inner {
              background-color: #2488ff;
              border-color: #2488ff;
            }
          }

          p {
            font-size: 10px;
            margin: 3px 0 0 7px;

            color: #000;
          }

          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: #000;
          }
        }
      }
    }

    .el-drawer {
      padding: 20px;
      padding-top: 0;
      z-index: 1001;
      overflow: auto;
      border-radius: 10px 10px 0 0;
      height: auto;
      max-height: calc(100vh - 20px);
    }
  }

  .bottom-drawer {
    .el-drawer.ttb {
      width: calc(100% - 322px);
      left: 290px;
      right: 0;
      // min-height: 300px !important;
      bottom: 20px;
    }
  }

  .top-drawer {
    .el-drawer.ttb {
      width: 500px;
      margin: auto;
      top: 60px;
      height: 70px !important;
      border-radius: 0 0 10px 10px;
      padding: 10px 15px;
      background-color: #2488ff;
      color: #ffff;
    }

    .el-icon-check {
      color: #079e3e;
      font-weight: bolder;
      border: 4px solid;
      border-radius: 50%;
      padding: 4px;
      background: #ffff;
      font-size: 18px;
      margin-right: 10px;
    }

    .main-div {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .check-outer {
        .name {
          font-size: 13px;
          font-weight: 700;
        }

        .duration {
          font-size: 13px;
          font-weight: 500;
          margin-top: 3px;
        }
      }

      .waiting-time-section {
        display: flex;
        align-items: flex-start;

        i {
          font-size: 18px;
          font-weight: 500;
          margin-right: 8px;
        }

        .head {
          font-weight: 600;
          font-size: 13px;
          margin-top: 3px;
        }

        .sub-text {
          font-size: 10px;
          font-weight: 500;
        }
      }
    }
  }

  .banner-drawer {
    .el-drawer__open .el-drawer.btt {
      -webkit-animation: btt-drawer-in 0.3s 1ms;
      animation: btt-drawer-in 0.3s 1ms;
      background-color: transparent;
      box-shadow: none;
      height: 230px !important;
    }
  }

  @media (max-width: 1283px) {
    .bottom-drawer {
      .el-drawer.btt,
      .el-drawer.ttb {
        // height: 70% !important;
        // width: calc(100% - 30px);
        // left: 15px;
      }
    }

    .background-container {
      width: 100%;
      margin-right: 10px;
      // margin-bottom: 58px;
    }

    .custom-drawer {
      width: 100% !important;
      left: 0 !important;
    }

    .chat-drawer {
      height: 45% !important;
    }
  }

  @media (max-width: 765px) {
    .chat-drawer {
      height: 55% !important;

      .drawer-content {
        flex-direction: column-reverse;

        .left-section {
          margin-top: 30px;
          padding-right: 0;
          width: 100%;
        }

        .right-section {
          padding: 0;
        }
      }
    }

    .start-chat-popup .el-dialog {
      width: 95%;
    }

    .chat-initiated .el-dialog {
      width: 250px !important;
    }
    .background-container {
    // margin-bottom:55px
  }
    .banner {
    top: 14px;
  }
  .text-left{
    margin-top: 25px
  }
  }

  @media (max-width: 520px) {
    .top-drawer .el-drawer.ttb {
      width: 95%;
      // height: 125px !important;
    }
    .chat-drawer {
      width: 100% !important;
      // left: -15px !important;
    }
    .background-container {
    // margin-bottom:50px
  }
  }

  @media (max-width: 457px) {
    .chat-drawer {
      .drawer-content .left-section,
      .drawer-content .right-section .inner-content,
      .drawer-content .right-section {
        width: 95%;
        padding: 0;
        margin: auto;
      }

      .drawer-content .left-section .inner-content {
        width: 100%;
        margin-top: 30px;
        padding: 0;
      }
    }

    .bottom-drawer {
      .el-drawer.btt,
      .el-drawer.ttb {
        padding-top: 0;
      }

      .el-drawer {
        // padding: 10px;
      }
    }
  }

  @media (max-width: 380px) {
    .top-drawer .el-drawer.ttb {
      width: 100%;
      height: 130px !important;
    }

    .top-drawer .main-div {
      flex-wrap: wrap;

      .waiting-time-section {
        justify-content: center !important;
        width: 100%;
        margin-top: 15px;
      }
    }
  }
}
</style>
